import PaymentPlanModal from '../../../../components/Purchasing/Order/PaymentsPlan/PaymentPlanModal'
import DateCell from '../../../../elements/Table/Cells/DateCell'
import React, { Fragment } from 'react'
import CustomTable from '../../../../elements/Table/CustomTable'
import { Button } from 'antd'
import MoneyCell from '../../../../elements/Table/Cells/MoneyCell'
import SumFooter from '../../../../elements/Table/Footers/SumFooter'

PaymentPlan.propTypes = {}

function PaymentPlan(props) {
  const { fetch, fetching, list, onShow, isUpdatable } = props
  const [columns] = React.useState(() => [
    {
      Header: 'ID',
      accessor: '_id',
      Cell: ({ value, original }) => <a onClick={() => onShow(original, 'edit')}>{value}</a>,
      hideDefault: true,
      hideable: true,
    },
    {
      Header: 'Name',
      accessor: 'name',
      Cell: ({ value, original }) => <a onClick={() => onShow(original, 'edit')}>{value}</a>,
    },
    { Header: 'Amount', accessor: 'amount', Cell: MoneyCell, Footer: SumFooter },
    { Header: 'Date', accessor: 'date', Cell: DateCell },
    { Header: 'Currency', accessor: 'currency' },
    { Header: 'Status', accessor: 'status' },
  ])

  return (
    <Fragment>
      <PaymentPlanModal {...props} />
      <CustomTable
        CreateButton={() => (
          <Button type={'primary'} size="small" icon={'plus'} onClick={onShow}>
            New
          </Button>
        )}
        fetch={fetch}
        data={list}
        fetching={fetching}
        columns={columns}
      />
    </Fragment>
  )
}

export default PaymentPlan
